module.exports = __webpack_public_path__ + "img/top_banner02.e5a1c50b.png";